import { FilterNameToAnalyticAction, FILTERS_NAME } from '../constants/filters';
import { ORGANIZATION_TYPE_TO_HEADER_MAP, OrganizationType } from '../constants/organizationType';
import { makeAdGEvent, pushEvent } from '../utils/analytics';

export const OrganizationTypeToAnalyticsTypeLabel: {
  [key in OrganizationType]: 'Банк' | 'Страховая компания';
} = {
  [OrganizationType.BANK]: 'Банк',
  [OrganizationType.INSURANCE_COMPANY]: 'Страховая компания',
};

export interface IAnalyticsTableItem {
  organizationType: OrganizationType;
  name: string;
}

export interface IAnalyticsFilterItem {
  filterName: FILTERS_NAME;
  filterValue: string;
}

export interface IAnalyticsWriteReviewItem {
  organizationType: OrganizationType;
}

export const itemLabelFactory = ({ organizationType, name }: IAnalyticsTableItem) => {
  return `${OrganizationTypeToAnalyticsTypeLabel[organizationType]}|${name}`;
};

export const sendGoToCardEvent = (item: IAnalyticsTableItem) =>
  pushEvent(
    makeAdGEvent({
      eventCategory: 'Рейтинги',
      eventAction: 'Переход в карточку',
      eventLabel: itemLabelFactory(item),
    }),
  );

export const sendGoToReviewsEvent = (item: IAnalyticsTableItem) =>
  pushEvent(
    makeAdGEvent({
      eventCategory: 'Отзывы',
      eventAction: 'Переход в отзывы',
      eventLabel: itemLabelFactory(item),
    }),
  );

export const sendGoToWriteReviewEvent = ({ organizationType }: IAnalyticsWriteReviewItem) =>
  pushEvent(
    makeAdGEvent({
      eventCategory: 'Отзывы',
      eventAction: 'Написать отзыв',
      eventLabel: `Клиентский рейтинг ${ORGANIZATION_TYPE_TO_HEADER_MAP[organizationType]}`,
    }),
  );

export const sendFilterEvent = ({ filterName, filterValue }: IAnalyticsFilterItem) =>
  pushEvent(
    makeAdGEvent({
      eventCategory: 'Рейтинги',
      eventAction: `Фильтры|${FilterNameToAnalyticAction[filterName]}`,
      eventLabel: filterValue,
    }),
  );
